"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VacanciesPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var section_swapper_1 = require("../../components/section_swapper");
var collage_png_1 = __importDefault(require("../../assets/vacancies/collage.png"));
var VacanciesPage = function (props) {
    var _a = props;
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "left", image: collage_png_1.default, smallTitle: "VACANCIES", bigTitle: "Join our family.", buttonText: "View Jobs", onButtonClick: function () {
                    window.open("https://thelocalchoice.simplify.hr", "_blank");
                }, description: "The Local Choice Pharmacy Group is built on a foundation of professional expertise and personal service, and we have been meeting customer's health care needs since 2011.", content: [
                    "With humble beginnings in Delmas in October 2011, we have grown into an organization of over 110 stores throughout South Africa becoming an indelible part of their communities. Yet despite our stellar growth, we have not forgotten our origins.",
                    "The Local Choice Franchise is an aligned, like-minded group of independent pharmacists, working together to help people get, feel, and live better. Local Choice Pharmacies take the time to offer personal care to each patient and to make a positive difference in their daily lives.",
                    "Our pharmacists are committed to open communication and the nurturing of relationships to the benefit of the individuals and the community's health.",
                    "In the current environment, where easy access to cost-effective care is paramount, The Local Choice's vision and mission are to provide a wide range of basic health care services in a convenient, cost-effective way.",
                ] }),
            react_1.default.createElement("iframe", { className: "rounded-lg shadow-lg mt-24", width: "100%", height: "420px", src: "https://www.youtube.com/embed/rvWKspHKeIE?rel=0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))));
};
exports.VacanciesPage = VacanciesPage;
